import React from 'react';
import Input, { type InputProps } from './Input';

interface InputWithLabelProps extends InputProps {
  label?: string;
  className?: string;
  inputClassName?: string;
  position?: 'top' | 'left';
}

function InputWithLabel({
  label = '',
  className = '',
  inputClassName = '',
  position = 'top',
  ...props
}: InputWithLabelProps) {
  return (
    <div
      className={`
    ${className}
    flex
    ${position === 'top' ? 'flex-col gap-2' : 'items-center gap-6'}
    `}
    >
      <label className="text-sm font-semibold">{label}</label>
      <Input {...props} className={inputClassName} />
    </div>
  );
}

export default InputWithLabel;
